// store.js
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        point_status: true, // 共享状态
    },
    mutations: {
        setPointStatus(state, data) {
            state.point_status = data;
        },
    }
});

export default store;